// ----------------------------------------------------------------------

const account = {
  displayName: '管理员',
  email: 'demo@minimals.cc',
  photoURL: `${process.env.PUBLIC_URL}/static/mock-images/avatars/avatar_default.jpg`
};

export default account;
